import StaticPage from "../../misc/StaticPage";

export default function LeaderboardExplainer(props) {

    return <StaticPage url={'https://www.schoolfeed.org/AppPages/learnmore.html'}/>
}
